import { render, staticRenderFns } from "./GraphDetail18.vue?vue&type=template&id=3241072c&scoped=true&"
import script from "./GraphDetail18.vue?vue&type=script&lang=js&"
export * from "./GraphDetail18.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3241072c",
  null
  
)

export default component.exports